const temporarySessionStorage = {};

export default {
    setItem: (key, value) => {
        try {
            window.sessionStorage.setItem(key, value);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            temporarySessionStorage[key] = value;
        }
    },
    getItem: key => {
        let value;

        try {
            value = window.sessionStorage.getItem(key);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            value = temporarySessionStorage[key];
        }

        return value;
    },
    removeItem: key => {
        try {
            window.sessionStorage.removeItem(key);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            delete temporarySessionStorage[key];
        }
    }
};
